const englishUrl = new URL(process.env.NEXT_PUBLIC_WEBSITE_PUBLIC_URL_ENGLISH)
const polishUrl = new URL(process.env.NEXT_PUBLIC_WEBSITE_PUBLIC_URL_POLISH)

export const getLocaleFromHostname = (hostname: string) => {
  if (hostname === englishUrl.hostname) {
    return 'en'
  }
  if (hostname === polishUrl.hostname) {
    return 'pl'
  }
  return 'de'
}
